import {BeforeYouthPlayerRecruitmentEvent} from "@/modules/youth/event/BeforeYouthPlayerRecruitmentEvent";

export class BeforeYouthPlayerTransferEvent extends BeforeYouthPlayerRecruitmentEvent {
}